module.exports = __webpack_public_path__ + "static/media/NotFoundLogo.6695af99.svg";